import { z } from 'zod'

export const CANONICAL_KINDS = ['canonical', 'record'] as const
export type CanonicalKind = (typeof CANONICAL_KINDS)[number]

const CanonicalClassificationStateSchema = z.object({
  classifier: z.string().min(1),
  fingerprint: z.string().min(1),
  canonicalProbability: z.number().min(0).max(1).nullable(),
  classifiedAt: z.string(),
})
export type CanonicalClassificationState = z.infer<
  typeof CanonicalClassificationStateSchema
>

const CanonicalClassificationSchema = z.object({
  canonicalKind: z.enum(CANONICAL_KINDS),
  canonicalState: CanonicalClassificationStateSchema,
})
export type CanonicalClassification = z.infer<
  typeof CanonicalClassificationSchema
>

export const ClassifyNoteCanonicalKindRequestSchema = z.object({
  noteId: z.string().min(1),
  title: z.string(),
  breadcrumb: z.string(),
  canonicalState: CanonicalClassificationStateSchema.nullable().catch(null),
})
export type ClassifyNoteCanonicalKindRequest = z.infer<
  typeof ClassifyNoteCanonicalKindRequestSchema
>

export const ClassifyNoteCanonicalKindResponseSchema = z.discriminatedUnion(
  'status',
  [
    z.object({ status: z.literal('up_to_date') }),
    z.object({
      status: z.literal('classified'),
      classification: CanonicalClassificationSchema,
    }),
    z.object({ status: z.literal('unavailable') }),
  ]
)
export type ClassifyNoteCanonicalKindResponse = z.infer<
  typeof ClassifyNoteCanonicalKindResponseSchema
>
